export default __webpack_public_path__ + "static/media/4_3_0.279a7aac.png";